module.exports = __webpack_public_path__ + "static/java-4488bea1d536039d13b2927a210e8fcc.png";